import logging from '../logging';


const log = logging('imw');

export type TypedArray = Int8Array | Uint8Array | Uint8ClampedArray | Int16Array
    | Uint16Array | Int32Array | Uint32Array | Float32Array | Float64Array;

export type TypedArrayConstructor = {
    new(): TypedArray;
}

export class Attr {
    size: number;
    count: number = 0;

    data: TypedArray;

    constructor(size: number) {
        this.size = size;
    }
}

export type AttrMap = Record<string, Attr>;

export class IndexedMesh<A extends AttrMap> {
    position = new Attr(3);
    index = new Attr(1);

    attrs: A;

    constructor(attrs: A) {
        this.attrs = attrs;
    }
}
